import { Icon, Typography } from '@/components/common';
import React from 'react';

interface EmptyStateFilterProps {
	icon: string;
	iconClassName?: string;
	message?: string;
	subMessage?: string;
	subMessageClassName?: string;
}
export const EmptyStateFilter: React.FC<EmptyStateFilterProps> = ({
	icon,
	iconClassName,
	message = 'There are currently no matches with this filter.',
	subMessage,
	subMessageClassName,
}) => {
	return (
		<div className="flex flex-col items-center">
			<Icon src={icon} width={190} height={61} className={iconClassName} />
			<Typography
				type="regular-18"
				className="font-normal text-center px-8 md:px-0"
			>
				<>
					{message}
					<br />
					<br />
					<span className={subMessageClassName}>{subMessage}</span>
				</>
			</Typography>
		</div>
	);
};
